import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {GreyButton} from "../../buttons/ButtonStyles";

const SearchBarByAdvancement = ({data, setData}) => {

    useEffect(() => {
        return () => {
            setData(data)
        }
    }, [data, setData])

    const advancementData = [
        {id: "not-started", title: "Pas commencées", minValue: 0, maxValue: 0},
        {id: "just-started", title: "Débutées", minValue: 1, maxValue: 25},
        {id: "advanced", title: "Bien avancées", minValue: 26, maxValue: 70},
        {id: "almost-done", title: "Presque terminées", minValue: 71, maxValue: 99},
        {id: "done", title: "Terminées", maxValue: 100, minValue: 100}
    ]

    const [selectedAdvancement, setSelectedAdvancement] = useState({})


    useEffect(() => {
        setData(data.filter(d => d.advancement >= selectedAdvancement.minValue && d.advancement <= selectedAdvancement.maxValue))
    }, [data, selectedAdvancement.maxValue, selectedAdvancement.minValue, setData])


    return (
        <Container>
            {advancementData.map(d => (
                <SelectButton key={d.id}
                              $mode={selectedAdvancement.id === d.id}
                              id={d.id}
                              onClick={() => setSelectedAdvancement(d)}
                >
                    {d.title}
                </SelectButton>
            ))}
        </Container>
    )
}


const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 70%;
`
const SelectButton = styled(GreyButton)`
`

export default SearchBarByAdvancement